// Loading.jsx
import React from 'react';
import { BarChart2, Box, RotateCw, TrendingUp } from 'lucide-react';

const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="mining-loader">
          <div className="cube-container">
            <div className="cube">
              <div className="face front"></div>
              <div className="face back"></div>
              <div className="face top"></div>
              <div className="face bottom"></div>
              <div className="face left"></div>
              <div className="face right"></div>
            </div>
          </div>
          <div className="data-flow">
            <BarChart2 className="data-icon" size={18} />
            <TrendingUp className="data-icon" size={18} />
          </div>
        </div>
        <p className="loading-text">Processing data...</p>
      </div>

      <style jsx>{`
        .loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(17, 24, 39, 0.8);
          backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        
        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, rgba(31, 41, 55, 0.8) 0%, rgba(17, 24, 39, 0.9) 100%);
          padding: 36px;
          border-radius: 18px;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.05);
        }
        
        .mining-loader {
          position: relative;
          width: 100px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
        }
        
        .cube-container {
          width: 50px;
          height: 50px;
          perspective: 120px;
        }
        
        .cube {
          width: 100%;
          height: 100%;
          position: relative;
          transform-style: preserve-3d;
          animation: rotate 3s infinite linear;
        }
        
        .face {
          position: absolute;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
          border: 1px solid rgba(255, 255, 255, 0.2);
          backface-visibility: visible;
        }
        
        .front {
          transform: rotateY(0deg) translateZ(25px);
          background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
        }
        
        .back {
          transform: rotateY(180deg) translateZ(25px);
          background: linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%);
        }
        
        .top {
          transform: rotateX(90deg) translateZ(25px);
          background: linear-gradient(135deg, #818CF8 0%, #A78BFA 100%);
        }
        
        .bottom {
          transform: rotateX(-90deg) translateZ(25px);
          background: linear-gradient(135deg, #3730A3 0%, #5B21B6 100%);
        }
        
        .left {
          transform: rotateY(-90deg) translateZ(25px);
          background: linear-gradient(135deg, #4338CA 0%, #6D28D9 100%);
        }
        
        .right {
          transform: rotateY(90deg) translateZ(25px);
          background: linear-gradient(135deg, #5B21B6 0%, #7C3AED 100%);
        }
        
        .data-flow {
          position: absolute;
          width: 100%;
          height: 100%;
          animation: pulse 2s infinite ease-in-out;
        }
        
        .data-icon {
          position: absolute;
          color: rgba(255, 255, 255, 0.8);
          filter: drop-shadow(0 0 8px rgba(138, 75, 255, 0.6));
        }
        
        .data-icon:nth-child(1) {
          top: 15%;
          left: 75%;
          animation: float 3s infinite ease-in-out;
        }
        
        .data-icon:nth-child(2) {
          bottom: 10%;
          right: 75%;
          animation: float 3s infinite ease-in-out 1.5s;
        }
        
        .loading-text {
          font-size: 16px;
          font-weight: 500;
          color: white;
          margin-top: 10px;
          background: linear-gradient(90deg, #4F46E5, #7C3AED);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: pulse-text 2s infinite;
        }
        
        @keyframes rotate {
          0% {
            transform: rotateX(0) rotateY(0);
          }
          100% {
            transform: rotateX(360deg) rotateY(360deg);
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
        }
        
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        
        @keyframes pulse-text {
          0%, 100% {
            opacity: 0.8;
          }
          50% {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Loading;
